<template>
    <div class="bg-white">
        <template >
            <div class="filter-bar mb20">
                <el-form :inline="true" @submit.native.prevent="submitSearch">
                    <el-form-item label="操作详情：">
                        <el-input v-model="tempQuery.result" @keyup.enter.native="submitSearch" @clear="submitSearch" clearable placeholder="根据操作详情关键字进行搜索" style="width: 260px;">
                            <el-button slot="append" icon="el-icon-search" @click="submitSearch"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="操作对象：">
                        <el-input v-model="tempQuery.operation_object" @keyup.enter.native="submitSearch" @clear="submitSearch" clearable placeholder="根据操作对象关键字进行搜索" style="width: 260px;">
                            <el-button slot="append" icon="el-icon-search" @click="submitSearch"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="操作人：">
                        <ESelect :value="queryData.user_id" @change="changeUserId" filterable multiple collapse-tags clearable placeholder="输入搜索或下拉选择操作人" style="width: 200px;">
                            <el-option value="all-option">全选</el-option>
                            <el-option v-for="item in userList" :label="item.name" :value="item.id" :key="item.id">
                                {{item.name}}
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="操作账户：">
                        <ESelect v-model="queryData.current_uid" @change="submitSearch" filterable clearable placeholder="输入搜索或下拉选择操作账户" style="width: 220px;">
                            <el-option v-for="item in accountList" :label="item.name" :value="item.id" :key="item.id">
                                {{item.name}}
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="操作模块：">
                        <ESelect :value="queryData.module_id" @change="changeModuleId" filterable multiple collapse-tags clearable style="width: 200px;">
                            <el-option value="all-option">全选</el-option>
                            <el-option v-for="item in moduleList" :label="item.name" :value="item.id" :key="item.id">
                                {{item.name}}
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="操作类型：">
                        <ESelect v-model="queryData.log_type" @change="submitSearch" filterable clearable style="width: 120px;">
                            <el-option label="全部" value="">全部</el-option>
                            <el-option v-for="item in logTypeList" :label="item.name" :value="item.id" :key="item.id">
                                {{item.name}}
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="操作时间：">
                        <el-date-picker
                            v-model="tempQuery.range_time"
                            @change="submitSearch"
                            style="width: 232px"
                            type="daterange"
                            align="center"
                            unlink-panels
                            :clearable="false"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            range-separator="~"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </div>
            <div class="data-list">
                <jt-table
                    v-loading="dataLoading"
                    :data="dataList"
                    stripe
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    :default-sort = "{prop: 'log_time', order: 'descending'}"
                    @sort-change="handleSortChange"
                    style="width: 100%">
                    <el-table-column
                        v-if="pageFieldsNames.includes('name')"
                        prop="name"
                        label="操作人"
                        align="center"
                        min-width="100">
                    </el-table-column>
                    <el-table-column
                        v-if="pageFieldsNames.includes('account')"
                        prop="account"
                        align="center"
                        label="操作账户"
                        min-width="100">
                        <template slot-scope="scope">
                            <span>{{scope.row.account||'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="pageFieldsNames.includes('log_time')"
                        prop="log_time"
                        sortable="custom"
                        :sort-orders="['ascending','descending']"
                        align="center"
                        key="log_time"
                        label="操作时间"
                        min-width="100">
                        <template slot-scope="scope">
                            <span>{{scope.row.log_time||'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="pageFieldsNames.includes('module')"
                        prop="module"
                        align="center"
                        min-width="100"
                        label="操作模块">
                        <template slot-scope="scope">
                            <span>{{scope.row.module||'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="pageFieldsNames.includes('log_type')"
                        prop="log_type"
                        align="center"
                        min-width="80"
                        label="操作类型">
                        <template slot-scope="scope">
                            <span>{{scope.row.log_type||'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="pageFieldsNames.includes('operation_object')"
                        prop="operation_object"
                        align="center"
                        min-width="80"
                        label="操作对象">
                        <template slot-scope="scope">
                            <span>{{scope.row.operation_object||'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="pageFieldsNames.includes('result')"
                        prop="result"
                        align="center"
                        min-width="180"
                        label="操作详情">
                        <template slot-scope="scope">
                            <div class="log-summary" >
<!--                                :title="getResultTitleText(scope.row.result)"-->
                                <div class="tal log-summary-text">
<!--                                    <div style="list-style: initial;" v-html="getResultText(scope.row.result)" @dblclick="textCopy(scope.row.result)"></div>-->
                                    <!--<pre>{{scope.row.result}}</pre>-->
                                    <el-tooltip placement="left" effect="light">
                                        <div slot="content" style="width: 550px;max-height: 80vh;overflow-y: auto;padding-right: 20px;"><div v-html="getResultText(scope.row.result)"></div></div>
                                        <div style="list-style: initial;" v-html="getResultText(scope.row.result)" @dblclick="textCopy(scope.row.result)"></div>
                                    </el-tooltip>
                                    <span v-if="scope.row.detail_url" class="text-color-primary pointer" @click="showBatchRoleInfo(scope.row)">
                                        查看详情
                                    </span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </jt-table>
                <div class="page-bar tac mt20">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryData.pn"
                        :page-sizes="[30,50,100]"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCnt">
                    </el-pagination>
                </div>
                <BatchRoleInfoModal v-if="showRoleConfig" ref="batchRoleInfoModal" :name="batchRoleName" :data="batchRoleData" @close="hideBatchRoleModal"/>
            </div>
        </template>
    </div>

</template>

<script>
    import API from '@/api/log/sys_operation_log.js';
    import utils from '@/libs/utils.js';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import BatchRoleInfoModal from '../../modal/batchRoleInfoModal';
    import {checkRoleInfoModal} from '../../modal/index';

    export default {
        name: "PcLog",
        props: {
            pageFieldsNames: {
                type: Array,
                default: () => [],
            },
        },
        components:{
            NoPermissionInfo,
            BatchRoleInfoModal,
        },
        data() {
            return {
                showRoleConfig:false,   // 是否加载【批量编辑角色】弹窗
                dataLoading: false,
                queryData: {
                    user_id: [],
                    current_uid: '',
                    module_id: [],
                    log_type: '',
                    range_time:'',
                    order_by:'log_time',
                    order_type:'desc',
                    pn: 1,
                    rn: 30,
                },
                tempQuery: {
                    result: '',
                    operation_object: '',
                    range_time: '',
                },
                userList: [],
                accountList: [],
                moduleList: [],
                logTypeList: [],
                dataList: [],
                totalCnt: 0,
                pickerOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time){
                        return time.getTime() > Date.now();
                    },
                    shortcuts:[
                        {
                            text: '今日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本周',
                            onClick(picker) {
                                // 本周：自然周，周一到周日
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let weekDay = date.getDay();
                                let endDate = year+'-'+month+'-'+day;
                                let startD = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
                                let startDate = startD.getFullYear()+'-'+(startD.getMonth()+1)+'-'+startD.getDate();
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate = year+'-'+month+'-1';
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本季度',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate='';
                                if([1,2,3].includes(month)){
                                    startDate = year+'-01-01';
                                }else if([4,5,6].includes(month)){
                                    startDate = year+'-04-01';
                                }else if([7,8,9].includes(month)){
                                    startDate = year+'-07-01';
                                }else if([10,11,12].includes(month)){
                                    startDate = year+'-10-01';
                                }
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                    ]
                },
                /* 为了解决默认排序显示问题，需配合列表的key使用 */
                pageFields:[{
                    name:'log_time'
                }],
                batchRoleName:'',
                batchRoleData:{},
            }
        },
        created() {
            this.getUserList();
            this.getAccountList();
            this.getModule();
            this.getLogType();
            this.initRangeTime();
            this.submitSearch();
        },
        methods: {
            initRangeTime() {
                let today = utils.formatDate(new Date());
                this.tempQuery.range_time = [today, today];
            },
            getUserList() {
                API.getUserList().then(res => {
                    let resData = res.data || {};
                    this.userList = resData;
                }, (err) => {
                    console.log('getUserList error', err);
                    this.userList = [];
                });
            },
            getAccountList() {
                API.getLogAccountList().then(res => {
                    let resData = res.data || {};
                    this.accountList = resData;
                }, (err) => {
                    console.log('getUserList error', err);
                    this.accountList = [];
                });
            },
            getModule() {
                API.getModule().then(res => {
                    let resData = res.data || {};
                    this.moduleList = resData;
                }, (err) => {
                    console.log('getModule error', err);
                    this.moduleList = [];
                });
            },
            getLogType() {
                API.getLogType().then(res => {
                    let resData = res.data || {};
                    this.logTypeList = resData;
                }, (err) => {
                    console.log('getLogType error', err);
                    this.logTypeList = [];
                });
            },
            getDataList() {
                this.dataLoading = true;
                API.getDataList({
                    current_uid: this.queryData.current_uid,
                    user_id: this.queryData.user_id,
                    module_id: this.queryData.module_id,
                    log_type: this.queryData.log_type,
                    result: this.queryData.result,
                    operation_object: this.queryData.operation_object,
                    range_time: this.queryData.range_time,
                    order_by:this.queryData.order_by,
                    order_type:this.queryData.order_type,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;
                    this.dataList = resData.list;
                    this.totalCnt = resData.totalCnt;
                }, (err) => {
                    console.log('getUserList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            changeUserId(val){
                if(val.includes('all-option')){
                    this.queryData.user_id = this.userList.map(item=>item.id);
                }else{
                    this.queryData.user_id = val;
                }
                this.submitSearch();
            },
            changeModuleId(val){
                if(val.includes('all-option')){
                    this.queryData.module_id = this.moduleList.map(item=>item.id);
                }else{
                    this.queryData.module_id = val;
                }
                this.submitSearch();
            },
            submitSearch(){
                this.queryData.pn = 1;
                this.queryData.result = this.tempQuery.result;
                this.queryData.operation_object = this.tempQuery.operation_object;
                this.queryData.range_time = this.tempQuery.range_time?this.tempQuery.range_time.join('/'):'';
                this.getDataList();
            },
            handleSizeChange(val) {
                this.queryData.rn= val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn= val;
                this.getDataList();
            },
            handleSortChange(column){
                this.queryData.order_type = column.order=='descending'?'desc':'asc';
                this.queryData.pn =1;
                this.getDataList();
            },
            showBatchRoleInfo(row){

                let batchRoleData = JSON.parse(row.new_data||"{}")||{};
                let roleList = batchRoleData.role_list||[];
                console.log('showBatchRoleInfo',batchRoleData,roleList)
                if(roleList.length>1){
                    this.showRoleConfig = true;
                    this.$nextTick(()=>{
                        this.batchRoleName = row.operation_object||"";
                        this.batchRoleData = JSON.parse(row.new_data||"{}")||{};
                        console.log('showBatchRoleInfo',this.batchRoleData);
                        this.$refs.batchRoleInfoModal.showModal();
                    })
                }else{
                    checkRoleInfoModal({
                        props: {
                            data: batchRoleData,
                        },
                        cbs:{}
                    });
                }
            },
            hideBatchRoleModal(){
                this.showRoleConfig = false;
                this.batchRoleName = '';
                this.batchRoleData = {};
            },
            getResultText(text){
                text = text||'';
                return text.replaceAll('\\r\\n','\r\n').split('\r\n').filter(item=>!!item).map(item=>`<p>◆ ${item}</p>`).join('');
            },
            getResultTitleText(text){
                text = text||'';
                return text.replaceAll('\\r\\n','\r\n').split('\r\n').filter(item=>!!item).map(item=>`◆ ${this.getText(item)}`).join('\r\n');
            },
            getText(text){
                let textCon = text||'';
                let tempDiv = document.createElement('div');
                tempDiv.innerHTML = textCon;
                let textStr = tempDiv.innerText;
                tempDiv.innerHTML = textStr;
                textStr = tempDiv.innerText;
                tempDiv.remove();
                return textStr;
            },


            textCopy(text){
                let result  = this.getResultTitleText(text);
                if (!navigator.clipboard) {
                    let ele = document.createElement("input");
                    ele.value = result;
                    document.body.appendChild(ele);
                    ele.select();
                    document.execCommand("copy");
                    document.body.removeChild(ele);
                    if (document.execCommand("copy")) {
                        console.log("复制成功1！");
                        this.$message.success('复制成功');
                    } else {
                        console.log("复制失败1！");
                    }
                } else {
                    navigator.clipboard.writeText(result).then(()=> {
                        console.log("复制成功2！");
                        this.$message.success('复制成功');
                    }).catch(function () {
                        console.log("复制失败2！");
                    })
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .filter-bar{
        background-color: #f8f8f9;
        padding: 20px 20px 0;
        border-radius: 5px;
    }
    .log-summary{
        max-height: 105px;

    }
    .log-summary-text{
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
    }
</style>
